import { useState, useEffect } from "react";
import { Col, Form, Modal, Row, Alert } from "react-bootstrap";
import { updateDropdownValue, addDropdownValue, getDropdownRecordsByFieldname } from "../../Services/dropdown-services";
import ConfirmAlertModal from "../Modals/confirmAlertModal";
import ButtonModal from "../Modals/buttonModal";
import { showSuccess, showWarning } from "../utility/ui/notifications/Toaster";
import { dropdownFields, refreshDropdown } from "../utility/common/DropdownComponent/DropdownHelper";
import SearchSelect from "../utility/forms/inputs/search-select";
import { normalstyle } from "../../functions/welding-functions";

const AddEditDropdownValueMaster = (props) => {
  let action = props.action;
  let formName = "Dropdown Value";
  const [showConfirmModel, setshowConfirmModel] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const [formObj, setFormObj] = useState(
    action === "Edit"
      ? props.rowdata
      : {
        wld_fieldName: "",
        wld_dropdownValue: "",
        wld_createdby: "",
        wld_createdon: "",
        wld_updatedby: "",
        wld_updatedon: "",
      }
  );

  const [error, setError] = useState({
    wld_fieldName: {},
    wld_dropdownValue: {},
    wld_createdby: {},
    wld_createdon: {},
    wld_updatedby: {},
    wld_updatedon: {},
  });

  const handleCloseConf = () => setshowConfirmModel(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormObj((prev) => ({ ...prev, [name]: value.trimStart() }));
    if (name === "wld_dropdownValue" && value && !/^[a-zA-Z0-9 \-/+&]+$/.test(value.trim())) {
      setError((prev) => ({ ...prev, [name]: { status: true, message: "Only alphanumeric, space, dash, slash, plus (+), and ampersand (&) allowed." } }));
    } else {
      setError((prev) => ({ ...prev, [name]: {} }));
    }
  };

  const resetForm = () => {
    if (action === "Edit") {
      setFormObj(props.rowdata);
    } else {
      setFormObj({ wld_fieldName: "", wld_dropdownValue: "" });
    }
    setError({ wld_fieldName: {}, wld_dropdownValue: {} });
    setAlertMessage("");
  };

  const validate = () => {
    let isError = false;
    const newError = { wld_fieldName: {}, wld_dropdownValue: {} };

    if (formObj.wld_dropdownValue && !/^[a-zA-Z0-9 \-/+&]+$/.test(formObj.wld_dropdownValue.trim())) {
      isError = true;
      return isError;
    }

    if (action === "Add" && (!formObj.wld_fieldName || formObj.wld_fieldName.trim() === "")) {
      isError = true;
      newError.wld_fieldName = { status: true, message: "Field Name is required." };
    }
    if (!formObj.wld_dropdownValue || formObj.wld_dropdownValue.trim() === "") {
      isError = true;
      newError.wld_dropdownValue = { status: true, message: "Value is required." };
    }

    if (!isError && props.allRecs) {
      const duplicate = props.allRecs.find(
        (item) =>
          String(item.wld_fieldName).toLowerCase() === formObj.wld_fieldName.trim().toLowerCase() &&
          String(item.wld_dropdownValue).toLowerCase() === formObj.wld_dropdownValue.trim().toLowerCase() &&
          (action === "Add" || item.SK !== formObj.SK)
      );
      if (duplicate) {
        isError = true;
        setAlertMessage("This Field Name and Value combination already exists!");
      }
    }
    setError(newError);
    return isError;
  };

  const getNextSeqNo = async (records) => {
    if (!records || records.length === 0) return 1;
    let maxSeq = 0;
    for (let i = 0; i < records.length; i++) {
      let sq = parseInt(records[i].SK.split("#")[records[i].SK.split("#").length - 1]);
      if (sq > maxSeq) maxSeq = sq;
    }
    return maxSeq + 1;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) {
      setshowConfirmModel(true);
    }
  };

  const handleConfirmYes = async () => {
    let result;
    if (action === "Add") {
      const data = await getDropdownRecordsByFieldname(formObj);
      const seqNo = await getNextSeqNo(data);
      formObj.wld_seqNo = seqNo;
      formObj.wld_createdby = sessionStorage.getItem("UserName");
      result = await addDropdownValue(formObj);
    } else {
      formObj.wld_updatedby = formObj.wld_createdby;
      result = await updateDropdownValue(formObj);
    }
    if (result?.status) {
      showSuccess(result.message);
      //To get the latest dropdown value list
      await refreshDropdown(formObj.wld_fieldName);
      props.setReload(!props.reload);
      props.onHide();
    } else {
      showWarning(result.message);
    }
    setshowConfirmModel(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => setAlertMessage(""), 10000);
    return () => clearTimeout(timer);
  }, [alertMessage]);

  return (
    <>
      <ConfirmAlertModal
        action={action}
        handleYes={handleConfirmYes}
        formName={formName}
        show={showConfirmModel}
        handleClose={handleCloseConf}
      />
      <Modal
        {...props}
        size="lg"
        centered
        className={showConfirmModel ? "opacity-0 userMasterModal" : "opacity-100 userMasterModal"}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{action} Dropdown Value</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit} autoComplete="off">
          <Modal.Body>
            <div className="px-2">
              <Row className="gx-3">
                <Col md={6}>
                  <Form.Group className="ListW-input-select">
                    <div className="search-select">
                      <SearchSelect
                        id="wld_fieldName"
                        name="wld_fieldName"
                        className={""}
                        stylegreen={normalstyle}
                        data={dropdownFields}
                        valueField={"fieldname"}
                        value={formObj.wld_fieldName}
                        labelField={"fieldname"}
                        placeholder=""
                        disabled={action === "Edit"}
                        onChange={(item) => {
                          handleChange({
                            target: { name: "wld_fieldName", value: item.value },
                          });
                        }}
                      ></SearchSelect>

                    </div>
                    <Form.Label className={action === "Add" ? "required-field" : ""} htmlFor="wld_fieldName">
                      Dropdown Field Name
                    </Form.Label>
                    &nbsp;&nbsp;
                    {error.wld_fieldName.status && (
                      <Form.Text className="text-danger">
                        <span style={{ position: "relative", bottom: "20px" }}>
                          {error.wld_fieldName.message}
                        </span>
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        type="text"
                        id="wld_dropdownValue"
                        name="wld_dropdownValue"
                        placeholder=" "
                        maxLength="100"
                        className={
                          error.wld_dropdownValue.status
                            ? "g-input placeHolderInput inputText text-field-with-error allow"
                            : "g-input placeHolderInput inputText allow"
                        }
                        value={formObj.wld_dropdownValue}
                        onChange={handleChange}
                      />
                      <Form.Label className="required-field" htmlFor="wld_dropdownValue">
                        Value
                      </Form.Label>
                    </div>
                    &nbsp;&nbsp;
                    {error.wld_dropdownValue.status && (
                      <Form.Text className="text-danger">
                        <span style={{ position: "relative", bottom: "20px" }}>
                          {error.wld_dropdownValue.message}
                        </span>
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </div>
            {alertMessage && (
              <Alert className="alertBox" variant="warning">
                {alertMessage}
              </Alert>
            )}
          </Modal.Body>
          <Row>
            <ButtonModal action={action} resetForm={resetForm} />
          </Row>
          <Row>
            <br />
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default AddEditDropdownValueMaster;
